import React, { FC, useEffect, useState } from "react";
import AlphaInsightsHeader from "../../components/AE2/AlphaInsightsHeader";
import Ae2Header from "../../components/AE2/Ae2Header";
import NotificationPopUp from "../../components/extras/NotificationPopUp";
import { useHistory, useParams } from "react-router";
import { API_URL } from "../../actions/settings";
import LoadingDots from "../../components/extras/LoadingDots";
import { isStaff } from "../../components/extras/Functions";
import { IonButton, IonCard, IonCardSubtitle, IonCardTitle, IonContent, IonIcon, IonPopover, IonRow } from "@ionic/react";
import CheckRole from "../../components/extras/CheckRole";
import { useSelector } from "react-redux";
import { selectUser } from "../../reducers/UserReducer";
import { menuOutline } from "ionicons/icons";
import VirtualMeterDataTable from "../../components/AE2/BuildingPageComponents/VirtualMeterDataTable"


interface IProps {};

interface Params {
    id:any
}

interface Meter{
    building?:string,
    id:string,
    is_virtual:boolean,
    name:string,
    source_meter_ids:string[]|null,
    source_meters:any,
    type:{
        id: string|number,
        name: string,
    }
    unitofmeasure:string,
    building_name:string|null
}

async function getMeter(token: string, id: string) {
  return fetch(`${API_URL}/virtual_meters/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Could not fetch data")
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Could not fetch data")
      });
}

async function getData(token: string, url: string) {
  return fetch(`${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Could not fetch data")
                return false
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Could not fetch data")
        return false
      });
}

const VirtualMeter:FC<IProps> = (props) => {
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';    
    const user = useSelector(selectUser)
    const history = useHistory()
    const [meter, setMeter] = useState<Meter|null>(null)
    const {id} = useParams<Params>()      
    const [url, setUrl] = useState(new URL (`${API_URL}/virtual_meters/${id}/data?page=1`))
    const [data,setData] = useState<any>({})

    useEffect(() => {
        const handleMeter = async () => {
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            const res = await getMeter(token, id);            
            if (res.status === 'success') {
                setMeter(res.data)
            }
            }
        handleMeter()
    }, [id] )

    useEffect(() => {
      const handleData = async () =>{
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const res = await getData(token, url.toString());
        if(res){
          setData(res)
        }
      }

      handleData();
    }, [id,url] );

    

    const handleFilters = (newUrl:any)=>{
      const handleData = async () =>{
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const res = await getData(token, newUrl.toString());
        if(res){
          setData(res)
        }
      }

      handleData();      
    }


    const copyUUID = () => {
    navigator.clipboard.writeText(meter?.id || '');
    const popup = document.getElementById("copied");
    popup?.classList.toggle("show");
    setTimeout(() => {
      const popup = document.getElementById("copied");
      popup?.classList.toggle("show");
    }, 3000);
    }

    if(!meter){
        return <LoadingDots/>
    }

    
    return <IonContent style={{overflowY:'auto'}}>
        { newUI ?
        <AlphaInsightsHeader/> : <Ae2Header/> }        
        <div style={{margin:'10px'}}>
            <div style={{display:'flex'}}>
                <h1 style={{verticalAlign:'middle'}}>{meter.name}</h1>                        
                {isStaff(user) ? (
                              <>
                                <span className="popup">
                                  <span className="popuptext" id="copied">
                                    Copied
                                  </span>                                          
                                </span>
                                <IonButton
                                        hidden={!CheckRole(user, ["Admin", "Supervisor"])}
                                        id="meter-btns"
                                        fill="clear"
                                        color="dark"
                                        slot="icon-only"
                                        >
                                        <IonIcon slot="icon-only" src={menuOutline}></IonIcon>
                                    </IonButton>
                              </>
                            ) : (
                              ""
                            )}
                
                            <IonPopover
                              trigger="meter-btns"
                              size="auto"
                              side="right"
                              alignment="start"
                              showBackdrop={false}
                            >
                              <IonContent>
                                <IonButton
                                  color="dark"
                                  fill="clear"
                                  expand="full"
                                    href={`/virtual_meter/${meter?.id}/edit`}                                    
                                >
                                  Edit Meter
                                </IonButton>
                                <IonButton
                                    className="clipboardButton"
                                    color="dark"
                                    fill="clear"
                                    expand="full"
                                    onClick={copyUUID}
                                >
                                    {/* <IonIcon md={copy} ios={copyOutline} /> */}
                                    COPY ID
                                  </IonButton>
                                                                        
                              </IonContent>
                            </IonPopover>
            </div>
            
            <div>
                (<a className="text-dark-blue" href={`/?id=${meter?.building}&sec=buildings&t=meters&m=virtual`}>{meter?.building_name}</a>)
            </div>
        </div>

        <div style={{margin:'20px'}}>
            <h3 className="text-dark-blue">Source Meters</h3>
            <IonRow className="grey-border-2pt">
                {meter.source_meters?.map((m:any) => {
                    return <IonCard key={m.id}
                        className="pointer"
                        style={{
                            padding:'1rem'
                        }}
                        onClick={()=>{
                            if(m.meter_id || !m.building){
                                history.push(`/energystar/meters/${m.id}`)
                            }
                            else{
                                history.push(`/internal_meter/${m.id}`)
                            }
                        }}>
                            <IonCardTitle>{m.name}</IonCardTitle>
                        <IonCardSubtitle>
                            {m.type?.name}
                        </IonCardSubtitle>
                    </IonCard>
                })}
            </IonRow>
        </div>

        <div className="Bills">
          <VirtualMeterDataTable id={id} data={data} name={meter?.name} url={url} setUrl={setUrl} type={meter?.type} handleFilters={handleFilters}/>
        </div>
        

    </IonContent>
};

export default VirtualMeter;